import { colors, fonts } from "@/lib/theme";
import {
  ExpandingLinesHeader,
  GrowingCircleHeader,
  OrganicStrokesHeader,
  MinimalLinesHeader,
  ElegantFrameHeader,
} from "./headers";

const sampleExhibits = [
  {
    title: "Birds in Flight",
    description:
      "A collection of crackle-glazed ceramic birds exploring movement, freedom, and the delicate balance between earth and sky.",
  },
  {
    title: "Contemplation",
    description:
      "Figurative works in white porcelain, capturing moments of quiet introspection and the grace found in stillness.",
  },
  {
    title: "Mother & Child",
    description:
      "Explorations of tenderness and connection, capturing the timeless bond between parent and child in sculptural form.",
  },
  {
    title: "Portraits",
    description:
      "Classical busts and portrait studies exploring texture, expression, and the subtle emotions captured in porcelain.",
  },
  {
    title: "New Works",
    description:
      "Recent explorations in form and texture, bridging classical technique with contemporary expression.",
  },
];

/**
 * Preview page to compare all header animation variants
 * Access via /header-preview route
 */
export function HeaderPreview() {
  return (
    <div style={{ backgroundColor: colors.background }}>
      {/* Navigation hint */}
      <div
        className="fixed top-5 left-1/2 -translate-x-1/2 z-50 px-6 py-3 rounded-full"
        style={{
          backgroundColor: "rgba(58, 58, 58, 0.9)",
          color: "white",
          fontFamily: fonts.sans,
          fontSize: "0.85rem",
        }}
      >
        Scroll down to see each header option animate
      </div>

      {/* Option 1: Expanding Lines */}
      <ExpandingLinesHeader {...sampleExhibits[0]} />
      <Spacer label="Option 2: Growing Circle Frame" />

      {/* Option 2: Growing Circle */}
      <GrowingCircleHeader {...sampleExhibits[1]} />
      <Spacer label="Option 3: Organic Brushstrokes" />

      {/* Option 3: Organic Strokes */}
      <OrganicStrokesHeader {...sampleExhibits[2]} />
      <Spacer label="Option 4: Minimal Vertical Lines" />

      {/* Option 4: Minimal Lines */}
      <MinimalLinesHeader {...sampleExhibits[3]} exhibitNumber={4} />
      <Spacer label="Option 5: Elegant Frame Build" />

      {/* Option 5: Elegant Frame */}
      <ElegantFrameHeader {...sampleExhibits[4]} />

      {/* End spacer */}
      <div
        className="h-[30vh] flex items-center justify-center"
        style={{
          backgroundColor: colors.border,
          fontFamily: fonts.sans,
          color: colors.textMuted,
          fontSize: "0.9rem",
        }}
      >
        End of examples
      </div>
    </div>
  );
}

function Spacer({ label }: { label: string }) {
  return (
    <div
      className="h-[50vh] flex items-center justify-center"
      style={{
        backgroundColor: colors.border,
        fontFamily: fonts.sans,
        color: colors.textMuted,
        fontSize: "0.9rem",
      }}
    >
      ↓ {label} ↓
    </div>
  );
}
